import { useState } from 'react';

export const useFormFields = initialState => {
  const [fields, setValues] = useState(initialState);
  return [
    fields,
    function (event) {
      setValues({
        ...fields,
        [event.target.id]: event.target.value,
      });
    },
  ];
};

//
export const capitalize = str => {
  if (!str) return;
  const regex = /(\b[a-z](?!\s))/g;
  return str.toLowerCase().replace(regex, x => x.toUpperCase());
};

// FORMAT MONEY
/**
 * Format number to currency
 */
export const formatCurrency = (amount, edit) => {
  // check to see that it's a valid number
  if (Number(amount) === Number.Nan) {
    return edit ? '' : '-';
  }
  const number = typeof amount === 'number' ? amount : Number(amount);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(number);
};

// removes middle name from full name
export const getFormattedName = name => {
  if (!name) return 'loading...';
  const temp = name
    .toLowerCase()
    .split(' ')
    .filter(el => el !== '');
  return temp.length > 2
    ? `${temp[0]} ${temp[temp.length - 1]}`
    : name.toLowerCase();
};

export const formatPhoneNumber = phoneNumberString => {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return '---';
};

export const checkRouteForString = (term, pathname) => pathname.includes(term);

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result;
      const base64 = result.split(',')[1]; // remove prefix: "data:<mime-type>;base64,"
      resolve(base64);
    };
    reader.onerror = (error) => reject(error);
  });
}

export const getPropertyType = typeNum => {
  switch (typeNum.toString()) {
    case '1':
    case '2':
      return 'SFR';
    case '3':
    case '4':
      return 'Condo (Attached)';
    case '5':
      return 'Condo (Detached)';
    case '6':
      return 'PUD';
    case '7':
      return 'Cooperative';
    case '8':
    case '9':
    case '10':
    case '11':
    case '12':
      return 'Manufactured';
    case '13':
      return 'Vacant Land';
    default:
      return '---';
  }
};